export default {

  loginRequest(state, user) {
    state.status = { loggingIn: true };
    state.user = user;
  },
  loginSuccess(state, user) {
    state.status = { loggedIn: true };
    state.user = user;
  },
  loginFailure(state) {
    state.status = {};
    state.user = null;
  },
  twoFactorRequired(state) {
    state.status = {};
    state.user = null;
  },
  logout(state) {
    state.status = {};
    state.user = null;
  },
  registerRequest(state, user) {
    state.status = { registering: true };
  },
  registerSuccess(state, user) {
    state.status = {};
  },
  registerFailure(state, error) {
    state.status = {};
  },
  changeCompany(state, company) {
    state.user.me.selected_company = company;
  },
  passwordChangeRequest(state) {
    state.status = { changingPassword: true }
  },
  passwordChangeSuccess(state) {
    state.status = { changedPassword: true };
  },
  passwordChangeFailure(state) {
    state.status = {};
  },
  setApiKey(state, apiKey) {
    state.user['apiKey'] = apiKey;
  }

}
